import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits.js";
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/list/listitemview
 */

import View from '../view';

/**
 * The list item view class.
 *
 * @extends module:ui/view~View
 */
var ListItemView = /*#__PURE__*/function (_View) {
  /**
   * @inheritDoc
   */
  function ListItemView(locale) {
    var _this;
    _classCallCheck(this, ListItemView);
    _this = _callSuper(this, ListItemView, [locale]);

    /**
     * Collection of the child views inside of the list item {@link #element}.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
    _this.children = _this.createCollection();
    _this.setTemplate({
      tag: 'li',
      attributes: {
        class: ['ck', 'ck-list__item']
      },
      children: _this.children
    });
    return _this;
  }

  /**
   * Focuses the list item.
   */
  _inherits(ListItemView, _View);
  return _createClass(ListItemView, [{
    key: "focus",
    value: function focus() {
      this.children.first.focus();
    }
  }]);
}(View);
export { ListItemView as default };